import { DomainInitPayload } from '@sxm-de/dev-kits/web-sdk/types';
import {
    isClientSdkBusinessError,
    logErrorFromClientSdk,
    trackBusinessError,
} from '@sxm-de/dev-kits/web-sdk/utils';

interface AddPasswordFnPayload {
    password: string;
}

export type AddPasswordFn = (payload: AddPasswordFnPayload) => Promise<void>;

export function initAddPasswordFn({
    dependencies,
}: DomainInitPayload): AddPasswordFn {
    const { clientSdk, appEventSdk } = dependencies;
    return async ({ password: newPassword }: AddPasswordFnPayload) => {
        try {
            const targetIdentityId = await clientSdk.user.getIdentityId();
            if (!targetIdentityId) {
                throw new Error();
            }
            await clientSdk.user.updatePassword({
                targetIdentityId,
                newPassword,
            });
            // TODO: add analytics
        } catch (error: any) {
            if (isClientSdkBusinessError(error)) {
                trackBusinessError(appEventSdk, {
                    ...error,
                    message: 'Password creation unsuccessful',
                });
            } else {
                logErrorFromClientSdk(error, dependencies);
            }
            throw new Error('SYSTEM');
        }
    };
}
